import React from 'react'

const Reconnect = (props) => {
  if (props.message === null || props.message.length <= 0) {
    return null
  }
  return (
    <div className="alert alert-danger text-center" role="alert">
      {props.message} <button className="btn btn-light btn-sm" onClick={() => props.reconnect()}>Reconnect</button>
    </div>
  )
}

export default React.memo(Reconnect)